import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from 'redux-thunk';
import rootReducer from "./reducers";

const middlewares = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export function configureStore(initialState) {
    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(
            applyMiddleware(...middlewares)
        ),
    );

    //sagaMiddleware.run(rootSaga);
    return store;
}